import { FormattedMessage, injectIntl } from 'react-intl';
import { Grid, Segment } from 'semantic-ui-react';

import CheckboxWidget from '@plone/volto/components/manage/Widgets/CheckboxWidget';
import PropTypes from 'prop-types';
import QuerystringWidget from '@plone/volto/components/manage/Widgets/QuerystringWidget';
import React from 'react';
import TokenWidget from '@plone/volto/components/manage/Widgets/TokenWidget';

const Sidebar = (props) => {
  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="SearchExperiencesBlock"
            defaultMessage="Ricerca esperienze"
          />
        </h2>
      </header>
      <Segment className="form sidebar-listing-data">
        <TokenWidget
          id="prices_filters"
          title="Fasce di prezzo"
          description="Seleziona le fascie di prezzo da mostare nei filtri della ricerca."
          widgetOptions={{
            vocabulary: {
              '@id': 'plone.app.vocabularies.Keywords',
            },
          }}
          value={props.data.prices_filters || []}
          onChange={(name, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              prices_filters: value,
            });
          }}
        />
        <div className="inline field">
          <CheckboxWidget
            id="show_results"
            title="Mostra risultati prima della ricerca"
            description="Selezionando questa opzione, nel blocco verranno mostrati i risultati della ricerca anche prima che l'utente abbia impostato dei criteri di ricerca."
            value={props.data.show_results}
            onChange={(name, value) => {
              props.onChangeBlock(props.block, {
                ...props.data,
                show_results: value,
              });
            }}
          />
        </div>
        <div className="inline field">
          <Grid>
            <Grid.Row stretched>
              <Grid.Column width={12}>
                <div className="simple-field-name">Criteri di default</div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row stretched>
              <Grid.Column width={12}>
                <p className="help">
                  Imposta il criterio di default per ricercare le esperienze
                  schedulate (realizzate con il tipo di contenuto Evento.)
                  <br /> Il criterio consigliato è: 'Categoria' ->
                  'Corrispondente a uno o più dei seguenti valori' e scegli le
                  categorie di esperienze con cui hai taggato gli eventi.
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <QuerystringWidget
          id="source"
          required={false}
          value={props.data.querystring || []}
          onChange={(name, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              querystring: value,
            });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default injectIntl(Sidebar);
